import React from "react";

const Github = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : "h-5 w-5"}
      width="32"
      height="32"
      viewBox="0 0 16 16"
    >
      <path d="M7.5 1C3.91 1 1 3.906 1 7.488c0 2.867 1.863 5.301 4.445 6.16.325.059.555-.273.555-.523 0-.152.004-.336 0-.875-1.809.39-2.375-.875-2.375-.875-.297-.75-.656-.965-.656-.965-.59-.402.043-.39.043-.39.652.043.988.605.988.605.5.875 1.629.79 2 .625 0-.398.043-.688.152-.871C4.11 10.019 2.996 8.839 3 7.207c.004-.965.336-1.715.875-2.27-.234-.296-.395-1.312.086-1.937 1.207 0 1.926.871 1.926.871s.566-.246 1.61-.246c1.046 0 1.608.234 1.608.234S9.828 3 11.035 3c.48.625.32 1.64.133 1.918.516.543.832 1.293.832 2.289 0 1.633-1.11 2.813-3.148 3.168.128.195.148.469.148.875v1.875c0 .25.227.586.559.523A6.497 6.497 0 0014 7.488C14 3.906 11.09 1 7.5 1z"></path>
    </svg>
  );
};

export default Github;
